import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Quota } from '../../../../models';
import styles from './ArticleLimitContent.module.scss';
import { ContactInformation } from '../../../ContactInformation';

const cx = classNames.bind(styles);

export interface ArticleLimitContentProps extends Omit<Quota, 'usageIncreased'> {
  onConfirm: () => void;
  onCancel: () => void;
  isInArticlePage?: boolean;
  isMyContent?: boolean;
}

const ArticleLimitContent = ({
  counter,
  limit,
  onConfirm,
  onCancel,
  usageExceeded,
  isInArticlePage = false,
  isMyContent = false,
}: ArticleLimitContentProps): ReactElement => {
  const renderArticleLimitContent = () => {
    return (
      <>
        <span className={cx('title')} data-testid="article-limit-content-title">
          <b>
            You have {limit - counter} of {limit} reports remaining
          </b>
        </span>
        <span className={cx('subtitle', 'is-aligned-center')} data-testid="article-limit-content-subtitle">
          Would you like to proceed?
        </span>
      </>
    );
  };

  const renderExceededArticleLimitContent = () => {
    return (
      <>
        <span className={cx('title')} data-testid="article-limit-content-title">
          <b>Your subscription has reached its limit.</b>
        </span>
        <span
          className={cx('subtitle', { 'is-aligned-center': isInArticlePage })}
          data-testid="article-limit-content-subtitle"
        >
          {
            'Avoid missing our indispensable insights by upgrading your account. To learn more, contact your account representative at '
          }
          <ContactInformation />.
        </span>
      </>
    );
  };

  return (
    <div className={cx('body')}>
      <div className={cx('count')} data-testid="article-limit-current">
        {Math.max(0, limit - counter)}
      </div>
      <div className={cx('content')} data-testid="article-limit-content">
        {!usageExceeded ? renderArticleLimitContent() : renderExceededArticleLimitContent()}
      </div>
      {isInArticlePage && (
        <div className={cx('actions')}>
          {!isMyContent && (
            <Button mode={!usageExceeded ? ButtonMode.SECONDARY : ButtonMode.PRIMARY} onClick={onCancel}>
              Go to Feeds
            </Button>
          )}
          {!usageExceeded && (
            <Button type="button" mode={ButtonMode.PRIMARY} onClick={onConfirm}>
              Continue
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ArticleLimitContent;
